var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group text-center my-3"},[_c('a',{staticClass:"btn btn-outline-secondary shadow-sm border-light px-3",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('more', 7)}}},[_c('i',{staticClass:"fa fa-calendar mr-1 opacity-7"}),_vm._v("\n    Select Another Day\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }